import {
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE,
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_SUCCESS,
    GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_FAIL,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_FAIL,
    GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_SUCCESS,
    GET_MOST_FREQUENT_ALERTS,
    GET_MOST_FREQUENT_ALERTS_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_FAIL,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_FAIL,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_SUCCESS,
    GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_FAIL,
    GET_MOST_FREQUENT_ALERTS_AZURE_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_AZURE_FAIL,
    GET_MOST_FREQUENT_ALERTS_AZURE,
    GET_MOST_FREQUENT_ALERTS_GCP,
    GET_MOST_FREQUENT_ALERTS_GCP_FAIL,
    GET_MOST_FREQUENT_ALERTS_GCP_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC_FAIL,
    GET_MOST_FREQUENT_ALERTS_NEW_RELIC_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_DATADOG,
    GET_MOST_FREQUENT_ALERTS_DATADOG_FAIL,
    GET_MOST_FREQUENT_ALERTS_DATADOG_SUCCESS,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_FAIL,
    GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_SUCCESS,
    GET_MOST_FREQUENT_OTHER_ALERTS,
    GET_MOST_FREQUENT_OTHER_ALERTS_FAIL,
    GET_MOST_FREQUENT_OTHER_ALERTS_SUCCESS, GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS
} from "./actionTypes";

const INIT_STATE = {
    alertLogCountIntegrationType: {},
    alertLogCountApplicationService: {},
    isAlertAnalyticsLoading: false,
    mostFrequentAlerts: [],
    alertOpenCloseWithin5Minutes: {},
    alertOpenCloseWithin5MinutesCount: {},
    mostfrequentalertsforoptimization: {},
    mostFrequentAlertsAzure: {},
    mostFrequentAlertsGCP: {},
    mostFrequentAlertsAWS: {},
    mostFrequentAlertsNewRelic: {},
    mostFrequentAlertsDatadog: {},
    mostFrequentAlertsExternalIntegrations: {},
    mostFrequentAlertsForOptimizationOpenCloseWithin5Minutes: {},

};

const AlertAnalytics = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }

        case GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_SUCCESS:
            return {
                ...state,
                alertLogCountIntegrationType: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_LOG_COUNT_BY_INTEGRATION_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }

        case GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_SUCCESS:
            return {
                ...state,
                alertLogCountApplicationService: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_LOG_COUNT_BY_APPLICATION_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_MOST_FREQUENT_ALERTS:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }

        case GET_MOST_FREQUENT_ALERTS_SUCCESS:
            return {
                ...state,
                mostFrequentAlerts: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_MOST_FREQUENT_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }

        case GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS:
            return {
                ...state,
                alertOpenCloseWithin5Minutes: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }

        case GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_SUCCESS:
            return {
                ...state,
                alertOpenCloseWithin5MinutesCount: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_ALERT_OPEN_AND_CLOSE_WITHIN_5_MINUTES_COUNT_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

       case GET_MOST_FREQUENT_ALERTS_AZURE:
           return {
               ...state,
               isAlertAnalyticsLoading: true,
           }
       case GET_MOST_FREQUENT_ALERTS_AZURE_SUCCESS:
           return {
               ...state,
               mostFrequentAlertsAzure: action.payload,
               isAlertAnalyticsLoading: false,
           }
        case GET_MOST_FREQUENT_ALERTS_AZURE_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_MOST_FREQUENT_ALERTS_GCP:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }
        case GET_MOST_FREQUENT_ALERTS_GCP_SUCCESS:
            return {
                ...state,
                mostFrequentAlertsGCP: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_GCP_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_CLOUDWATCH:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }
        case GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_SUCCESS:
            return {
                ...state,
                mostFrequentAlertsAWS: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_CLOUDWATCH_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_NEW_RELIC:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }
        case GET_MOST_FREQUENT_ALERTS_NEW_RELIC_SUCCESS:
            return {
                ...state,
                mostFrequentAlertsNewRelic: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_NEW_RELIC_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_DATADOG:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }
        case GET_MOST_FREQUENT_ALERTS_DATADOG_SUCCESS:
            return {
                ...state,
                mostFrequentAlertsDatadog: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_DATADOG_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_MOST_FREQUENT_OTHER_ALERTS:
            return {
                ...state,
                isAlertAnalyticsLoading: true,
            }

        case GET_MOST_FREQUENT_OTHER_ALERTS_SUCCESS:
            return {
                ...state,
                mostFrequentAlertsExternalIntegrations: action.payload,
                isAlertAnalyticsLoading: false,
            }

        case GET_MOST_FREQUENT_OTHER_ALERTS_FAIL:
            return {
                ...state,
                error: action.payload,
                isAlertAnalyticsLoading: false,
            }
        case GET_MOST_FREQUENT_ALERTS_OPEN_AND_CLOSE_WITHIN_5_MINUTES_SUCCESS:
            return {
                mostFrequentAlertsForOptimizationOpenCloseWithin5Minutes: action.payload,
                isAlertAnalyticsLoading: false
            }

        default:
            return state
    }
}

export default AlertAnalytics;
